import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAccessControl } from '../context/useAccessControl';
import { getInternalAssistantEnvironment } from '../../services/local/internalAssistantRuntime';
import { canPrepareRestaurant, readSetupProgress, setupStorageKey } from '../../services/local/restaurantSetup';
import { getRestaurantProfile } from '../../services/local/restaurantProfile';
import { isDeliveryOnly, MERCHANT_HOME_PATH } from '../../services/local/merchantExperience';
import '../../styles/RestaurantSetup.css';

export default function RestaurantSetupEntry() {
  const access = useAccessControl();
  const { pathname } = useLocation();
  const environment = getInternalAssistantEnvironment();
  if (!canPrepareRestaurant(access, environment) || pathname === '/app/preparar' ||
    pathname === MERCHANT_HOME_PATH || pathname === `${MERCHANT_HOME_PATH}/`) return null;
  const branch = access.currentBranch || access.currentRestaurant;
  const deliveryOnly = isDeliveryOnly(getRestaurantProfile(branch));
  const progress = readSetupProgress(setupStorageKey(environment, access.user.id, access.currentCompany.id, branch.id));
  const home = pathname === '/app' || pathname === '/app/';
  if (!home && !progress.started) return null;
  if (!home && !['/app/menu', '/app/configuracion', '/app/restaurante', '/app/stock', '/app/ingredientes',
    deliveryOnly ? '/app/pedidos' : '/app/qr'].includes(pathname)) return null;
  return <aside className="restaurant-setup-entry" aria-label={deliveryOnly ? 'Preparacion del delivery' : 'Preparacion del restaurante'}>
    <div><strong>{home ? (deliveryOnly ? 'Preparar mi delivery' : 'Preparar mi restaurante') : 'Tu preparacion sigue guardada'}</strong>
      <p>{home ? (deliveryOnly ? 'Tu carta, delivery y retiro, WhatsApp y zonas de entrega. Una tarea por vez.' : 'Tu carta, tus canales y una revision final. Una tarea por vez.') : 'Volve al recorrido para continuar con el siguiente paso.'}</p></div>
    <Link to="/app/preparar">{progress.started ? 'Continuar preparacion' : 'Empezar paso a paso'}</Link>
  </aside>;
}
